<template>
<m-pageframe
    title="{organization-label}: Introduction Settings"
>
<v-container
    fluid
    style="padding-left: 25px; padding-right: 25px;"
    v-if="settings != null"
>

    <b>Image(s)</b><br/>

    
    <div
        :style="imageCardStyle(item)"
        v-for="(item, index) in settings.images"
        :key="index"
    >
        <img
            :src="item.logo_image_url"
            style="width: 300px;"
        />
        <br/>

        <div
            style="position: absolute; top: 10px; right: 10px"
        >
        <v-menu 
            bottom 
            offset-y  
        >
        
        <template v-slot:activator="{ on }">
                
            <v-icon 
                v-on="on"
            >
                mdi-dots-vertical
            </v-icon>
                
        </template>
        
        <v-list>
            <v-list-item
                v-on:click="onClickMakeDefault(item)"
                v-if="item.is_default == false"
            >
                <v-list-item-title>Make default</v-list-item-title>
            </v-list-item>

            <v-list-item
                v-on:click="onClickDeleteImage(item)"
            >
                <v-list-item-title>Delete image...</v-list-item-title>
            </v-list-item>
        
        </v-list>
        
        </v-menu> 
        </div>
    
        
    </div>


    <m-icon-bar
        style="margin-bottom: 15px;"
        v-on:add="onClickAddImage"
    />

    <m-widget-settings-upload-avatar-confirm-dialog
        ref="upload-avatar-confirm-dialog"
    />

    <m-edit-blobs-dialog
        ref="upload-blob-dialog"
        title="Upload Image"
        v-on:ok="afterUploadImage($event)"
        :externally_visible="true"
        :show_send_as_links="false"
        :organization_id="$route.params.organization_id"
    />

    
    <m-edit-message-patterns
        v-model="settings.message_patterns"
        context="introduction"
        v-on:input="onUpdateMessagePatterns"
        always_mms
    />
    

</v-container>
</m-pageframe>
</template>

<script>
export default {

    data() {
        return {
            settings: null,
        }
    },

    mounted () {
        this.update();
    },
    
    methods: {
        update()
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'GET: /api/v1/introduction/org-profile/:organization_id',
            
                {
                    'organization_id' : this.$route.params.organization_id,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.settings = data;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to get introduction settings');
                },
            );
        },


        onClickDeleteImage(item)
        {
            this.$rc.confirm(
                'Delete image',
                'Are you sure that you want to permenantly delete this image?',
                [
                    {'text': 'Cancel', 'value': 'cancel'},
                    {'text': 'Delete', 'value': 'confirm'},
                ],
            
                (response) => {
                    if (response != 'confirm') return;
                    
                    this.onConfirmDeleteImage(item);
                }
            );
        },

        onConfirmDeleteImage(item)
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'DELETE: /api/v1/introduction/image',
            
                {
                    'image_id': item.image_id
                },
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.update();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onClickMakeDefault(item)
        {
            item.is_default = true;
            this.putImage(item);
        },

        putImage(item)
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'put: /api/v1/introduction/image',
            
                item,
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.update();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        imageCardStyle(item)
        {
            if ( item.is_default )
                return 'display: inline-block; margin: 15px; text-align: center; padding: 15px; border: 3px solid rgba(0,0,0,0.2); border-radius: 10px; position: relative;';
            else
                return 'display: inline-block; margin: 15px; text-align: center; padding: 15px; border: 1px solid rgba(0,0,0,0.2); border-radius: 10px; position: relative;';
        },

        onClickAddImage()
        {
            this.$refs['upload-avatar-confirm-dialog'].showDialog(this.onAcceptTermsOfImageUpload); 
        },

        onAcceptTermsOfImageUpload()
        {
            this.$refs['upload-blob-dialog'].showDialog([],true);
        },

        afterUploadImage(blob_ids)
        {
            this.$rc.showSpinner();
            
            this.$rc.getBlobMetaDataMultiple(
                blob_ids,
            
                (data) => {
                    this.$rc.hideSpinner();

                    for ( let i = 0; i < data.meta_data.length; i++ )
                    {
                        let img = new Image();
                            img.onload = () => {
                                let width = img.width;
                                let height = img.height;

                                if ( Math.abs(width-height) / height < 0.05 )
                                {
                                    let params = {
                                        'organization_id' : this.$route.params.organization_id,
                                        'image_id': this.$rc.uuidv4(),
                                        'logo_image_url': img.src,
                                        'logo_image_blob_id': data.meta_data[i].blob_id,
                                        'is_default' : this.settings.images.length == 0
                                    };

                                    this.putImage(params);
                                }
                                else
                                {
                                    this.$rc.alert('Error', 'Unable to add image: image is not square');
                                }
                            }

                        img.src = 'https://files.redchirp.com/'+data.meta_data[i].object_name;
                    }
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to add image(s)');
                },
            );
        },

        onUpdateMessagePatterns()
        {
            
            this.$rc.rest(
                'PUT: /api/v1/introduction/settings',
            
                this.settings,
            
                (data) => {
                },
            
                () => {
                    this.$rc.alert('Error','Unable to save settings');
                },
            );
        },
    }, 
}
</script>

<style lang="scss" scoped>
</style>